export const DEFAULT_RINGBA_CAMPAIGN_SRC =
  "//b-js.ringba.com/CAb3f0d44bca814dfeb37d893d5da0b2b6";

export const TEXAS_RINGBA_CAMPAIGN_SRC =
  "//b-js.ringba.com/CA049843d258d74b3a8861900cb6d0b25c";

const TEXAS_LANDING_PAGE_PATH = "/cheap-home-insurance-tx";

export function getRingbaCampaignSrc(pathname: string): string {
  const normalizedPathname =
    pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;

  return normalizedPathname === TEXAS_LANDING_PAGE_PATH
    ? TEXAS_RINGBA_CAMPAIGN_SRC
    : DEFAULT_RINGBA_CAMPAIGN_SRC;
}
